import { Component, OnDestroy, OnInit } from '@angular/core';
import { CreateEditInstructionsViewMode, MutualFundInvestingService } from '../mutual-fund-investing.service';
import {
  CreateEditInstructionsModel,
  OpenInstructionModel
} from '../create-edit-instructions/create-edit-instructions.model';
import { Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { IntegrationService } from '../../shared/services/integration.service';
import { AmountTypeValues } from '../../shared/constants/filter-constants';
import { NgClass } from '@angular/common';

@Component({
    selector: 'instruction-actions',
    templateUrl: './instruction-actions.component.html',
    styleUrls: ['./instruction-actions.component.scss'],
    imports: [NgClass]
})
export class InstructionActionsComponent implements OnInit, OnDestroy {
  @Input()
  instructionData: CreateEditInstructionsModel;

  private instructionStatusSub: Subscription;
  public editIcon: string;

  constructor(
    private mfInvestingService: MutualFundInvestingService,
    private integrationService: IntegrationService
  ) {}

  ngOnInit(): void {
    this.instructionStatusSub = this.mfInvestingService.updateInstructionStatus$.subscribe((instruction) =>
      this.instructionUpdated(instruction)
    );
    this.editIcon = this.integrationService.getApplicationPath() + 'assets/images/Icon_Edit_Active_default.svg';
  }

  ngOnDestroy(): void {
    this.instructionStatusSub.unsubscribe();
  }

  stopInstruction(event): void {
    event.preventDefault();
    this.mfInvestingService.stopInstruction(this.instructionData);
  }

  deleteInstruction(event): void {
    event.preventDefault();
    this.mfInvestingService.deleteInstruction(this.instructionData);
  }

  editInstruction(event): void {
    event.preventDefault();
    const editInstruction: OpenInstructionModel = {
      instruction: this.instructionData,
      mode: CreateEditInstructionsViewMode.EDIT_INSTRUCTION
    };
    this.mfInvestingService.openCreateEditInstructions(editInstruction);
  }

  isEmployeeAccount(): boolean {
    return this.integrationService.getIsEmployee();
  }

  private instructionUpdated(instruction: CreateEditInstructionsModel): void {
    this.instructionData = instruction;
  }

  private convert(amt: string, type: string): string {
    if (!amt) {
      return '';
    }
    let value = '';
    if (type === AmountTypeValues.dollars) {
      const formattedValue = parseFloat(amt)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      value = '$' + formattedValue;
    } else {
      const formattedValue = parseFloat(amt)
        .toFixed(3)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      value = formattedValue;
    }
    return value;
  }
}
